<template>
    <div class="input_container">
        <van-field v-model="localValue" right-icon="user-circle-o"
            :type="isShow && props.isPassword ? 'password' : props.fieldType" :maxlength="props.isPassword ? 20 : 'none'"
            :placeholder="props.labelText">
            <template #left-icon  v-if="props.isPassword">
                <div>
                    <img  src="@/assets//profile/blockimage.png" alt="" width="30px"
                        class="iconImage" @click="handleShowPassword" />
                </div>
            </template>
            <template #right-icon>
                <div v-if="props.isPassword">
                    <img v-if="isShow" src="@/assets/loginRegister/showEye.png" alt="" width="18px"
                        class="iconImage" @click="handleShowPassword" />
                    <img v-else src="@/assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
                        @click="handleShowPassword" />
                </div>
            </template>
        </van-field>
    </div>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue'
import type { FieldType } from 'vant'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    fieldType: {
        type: String as () => FieldType,
        default: () => 'text'
    },
    isPassword: {
        type: Boolean,
        default: () => false
    },
    labelText: {
        type: String,
        default: () => ''
    },
})

const isShow = ref(true)
const emit = defineEmits(['update:modelValue', 'valueChanged'])

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})
const handleShowPassword = () => {
    isShow.value = !isShow.value
}


</script>
<style scoped>
/* Base field style */
.input_container >>> .van-field {
  border-radius: 5px;
  border: 0.02667rem solid #00615f;
  background: #002121;
  color: #ffffffd9;
  padding: 14px 15px !important;
  margin: 20px 0px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

/* ✅ Focused (active) state */
.input_container >>> .van-field:focus-within {
  background: #00212172  !important;
  border-color: #01918e !important;
}

/* Input text */
.input_container >>> .van-field__control {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 15px;
  display: flex;
  align-items: center;
}

/* ✅ Placeholder color */
.input_container >>> .van-field__control::placeholder {
  color: #6d788d !important; /* adjust opacity as needed */
  font-family: inherit; /* optional: match your design */
  font-size: 15px;
}

/* Icons center-aligned */
.input_container >>> .van-field__left-icon,
.input_container >>> .van-field__right-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconImage {
  opacity: 1;
  vertical-align: middle;
  display: inline-block;
}

</style>